import { TAuthState } from '@/redux/reducers/auth';
import { TVerifyOtpSuccess } from '@/redux/actions/auth';

export const verifyOtpUpdateState = (state: TAuthState, action: TVerifyOtpSuccess): TAuthState => ({
  ...state,
  verifyOtpResponse: action.payload.response,
});
